import { IAppEnum } from "lib/enum/app.enum";
import { IWorkingDaysAnalyticsActivityEnum, IWorkingDaysAnalyticsActivityV2Enum } from "lib/enum/working-days-analytics-activity.enum";

export interface TopAppsReportRaw {
    [IWorkingDaysAnalyticsActivityEnum.TotalDuration]: string,
    [IWorkingDaysAnalyticsActivityEnum.LocalStartTime]: string,
    [IAppEnum.Name]: string,
    [IWorkingDaysAnalyticsActivityEnum.AppId]: string,
    [IAppEnum.LogoUrl]: string,
    [IAppEnum.DisplayColor]: string,
}

export interface TopAppsReportV2Raw {
    [IWorkingDaysAnalyticsActivityV2Enum.TotalDuration]: string,
    [IWorkingDaysAnalyticsActivityV2Enum.LocalStartTime]: string,
    [IWorkingDaysAnalyticsActivityV2Enum.AppId]: string,
}